import script from "./SidebarJobs.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarJobs.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__